import { PaymentConditions } from "../enums/WiypEnum";
import { StatusV2, Transfer, Traveller } from "..";
import { LuggageDetails, Transport } from "./Transport"
import { EsfDetails } from "./EsfDetails";

export interface WiypDto {
    agentId?: string;
    agentDate?: string;
    boReference: string;
    liheId: number;
    numberOfPax: number;
    packageCode?: string;
    packageId: string;
    departureDate: string; // ISO 8601 format
    returnDate: string; // ISO 8601 format
    status: StatusV2;
    website: string;
    sellingPrice?: number;
    publicPrice?: number;
    purchasePrice?: number;
    alternative?: Alternative;
    origin?: string;
    destination?: string;
    paymentConditions?: PaymentConditions;
    cancellationUntil?: string;
    options: WiypDtoOption[];
    travellers: Traveller[];
    promocode?: {
        code: string,
        percentage: number,
        amount?: number
    };
    updatedAt?: string;
    clientEmail?: string;
    forceFull?: boolean;
    company?: string;
    companyLang?: string;
    numeroUsager?: string;
    destinationStationId?: string | null;
}

export class WiypDtoOption {
    id: string;
    familyId?: number;
    name: string;
    prestId?: number;
    prestTypeId: number;
    quantity: number;
    maxCapacity?: number;
    providerId?: number;
    sellingPrice?: number;
    nominative?: boolean;
    startDate?: string;
    endDate?: string;
    default?: boolean;
    mandatory?: boolean;
    pricePerTraveller?: PricePerTraveller[];
    details?: Transport | Transfer | LuggageDetails | TNEDetails | EsfDetails;
    // Especially for commercial-discount
    comments?: string | null;
    key?: string | null;
    agentId?: string | null;
    travellers?: string[];
}

export class PromocodeDTO {
    code: string;
    domain: string;
    requester: string;
    percentage?: number | null;
    startActivation?: string | null;
    endActivation?: string | null;
    codeIresa?: string | null;
    maxUsage?: number | null;
    currentUsage?: number | null;
    ruleId?: string | null;
    company?: string | null;
    secure?: string | null;
}

export type PricePerTraveller = {
    id: string;
    price: number;
    selected: boolean;
    purchasePrice?: number;
}

// Define the type explicitly
export type Alternative = "flight" | "train" | "transfer" | "service";

// Use the type to create a constant (valid values)
export const VALID_ALTERNATIVES: Alternative[] = ["flight", "train", "transfer", "service"];

export class WiypPaymentsDTO {
    payments: {
        amount: number;
        date: string;
    }[];
    paymentConditions?: PaymentConditions;
}


export enum TrainClass {
    COUCHETTE_STANDARD = "CouchetteStandard",
    COUCHETTE_PLUS = "CouchetteStandardPlus",
    ASSISES = "PlacesAssises",
    COMPARTMENT_STANDARD = "CompartimentStandard",
    COMPARTMENT_PLUS = "CompartimentStandardPlus",
    COMPARTMENT_PREMIUM = "CompartimentPremière",
}

export class TNEDetails {
    trainClass: TrainClass;
}